import { ActivatedRouteSnapshot, CanActivate,Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContentMapperService } from '../services/content-mapper-service';
import user_endpoint from '../../data/api-endpoint/user-endpoint';
import { ToastrService } from 'ngx-toastr';
import Cookie from 'js-cookie';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private commonService: CommonService, private _contentMapper: ContentMapperService, private router: Router, private toastr: ToastrService) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const needsFetch = !localStorage.getItem('user');
    const user$ = needsFetch ? this.fetchUserDetail() : this.commonService.getUserDetail();

    return user$.pipe(
      map((user: any) => {
        const permissions = Array.isArray(user?.permissions_ids) ? user.permissions_ids : [];
        if(permissions.includes(route.data['permission'])){
          return true;
        } else {
          if(!permissions.includes(10)){
            localStorage.clear();
            Cookie.remove('ttd-session');
            this.toastr.warning('You don\'t have permission to perform this action. Please contact your administrator if you believe this is an error.', 'Access Denied');
            this.router.navigate(['/login']);
            return false;
          }
          this.router.navigate(['/content-pool']);
          return false;
        }
      }),
      catchError(() => of(false))
    );
  }

  fetchUserDetail() {
    return this._contentMapper.get(user_endpoint.currentUserDetail).pipe(map((response: any) => {
      localStorage.setItem('user', JSON.stringify(true));
      localStorage.setItem('user_detail', JSON.stringify(response.results));
      this.commonService.updateUserDetail(response.results);
      return response.results;
    }), catchError((error: any) => {
      console.error('Error occured while fetching user detail', error.message);
      localStorage.clear();
      Cookie.remove('ttd-session');
      this.toastr.warning('You don\'t have permission to perform this action. Please contact your administrator if you believe this is an error.', 'Access Denied');
      this.router.navigate(['/login']);
      return of({});
    }))
  }

}

